"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Column", {
  enumerable: true,
  get: function get() {
    return _Column.default;
  }
});
exports.Columns = exports.componentTypeIsSame = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactMedia = _interopRequireDefault(require("react-media"));

var _Column = _interopRequireDefault(require("./Column"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var componentTypeIsSame = function componentTypeIsSame(Component, type) {
  // https://github.com/gatsbyjs/gatsby/issues/3486#issuecomment-364163889
  return type === Component || type === _react.default.createElement(Component, null).type;
};

exports.componentTypeIsSame = componentTypeIsSame;

var Columns = function Columns(_ref) {
  var children = _ref.children,
      className = _ref.className,
      middle = _ref.middle,
      gutterSize = _ref.gutterSize,
      gutters = _ref.gutters,
      split = _ref.split,
      reverse = _ref.reverse,
      stack = _ref.stack,
      stackMaxWidth = _ref.stackMaxWidth;
  var gutterUnit = gutterSize || gutters && 1; // Verify and augment children columns

  children = _react.default.Children.map(children, function (child) {
    if (!child) return;
    if (!componentTypeIsSame(_Column.default, child.type)) throw new Error('<Columns> can only have <Column> as a direct child');
    return _react.default.cloneElement(child, _objectSpread({}, child.props, {
      stack: stack,
      gutterUnit: gutterUnit,
      split: split
    }));
  }); // When stack is enabled, we don't return traces of the columns div tags

  if (stack) return _react.default.createElement(_react.Fragment, null, children);
  var styles = {
    display: 'flex',
    boxSizing: 'borderBox'
  };
  if (middle) styles.alignItems = 'center';
  if (split) styles.justifyContent = 'space-between';
  if (reverse) styles.flexDirection = 'row-reverse';
  if (gutterUnit) styles.marginLeft = "".concat(gutterUnit * -0.5, "em");
  if (gutterUnit) styles.marginRight = "".concat(gutterUnit * -0.5, "em");
  var classNames = (0, _classnames.default)('react-flex-columns', className, {
    'react-flex-columns-align-middle': !!middle,
    'react-flex-columns-split': !!split,
    'react-flex-columns-reverse': !!reverse
  }); // If we're using the responsive settings

  if (stackMaxWidth) {
    return _react.default.createElement(_reactMedia.default, {
      query: "(max-width: ".concat(Number.isInteger(stackMaxWidth) ? "".concat(stackMaxWidth, "px") : stackMaxWidth, ")")
    }, function (stack) {
      if (stack) return _react.default.createElement(_react.Fragment, null, children);
      return _react.default.createElement("div", {
        className: classNames,
        style: styles
      }, children);
    });
  }

  return _react.default.createElement("div", {
    className: classNames,
    style: styles
  }, children);
};

exports.Columns = Columns;
Columns.defaultProps = {
  middle: false,
  gutterSize: null,
  gutters: null,
  split: false,
  reverse: false,
  stack: false
};
Columns.propTypes = {
  className: _propTypes.default.string,
  middle: _propTypes.default.bool,
  gutterSize: _propTypes.default.number,
  gutters: _propTypes.default.bool,
  split: _propTypes.default.bool,
  reverse: _propTypes.default.bool,
  stack: _propTypes.default.bool,
  stackMaxWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flex-columns/build/Columns.js
// module id = 93
// module chunks = 0